<template>
  <dl class="grid grid-cols-1 gap-y-8">
    <div>
      <dt class="text-sm font-medium text-gray-500">Audience name</dt>
      <dd class="mt-1 text-sm text-gray-900">
        {{ audience.model.name }}
      </dd>
    </div>
    <div>
      <dt class="text-sm font-medium text-gray-500">Estimated audience size</dt>
      <dd class="mt-1 text-sm text-gray-900">
        {{ estimatedSize }}
      </dd>
    </div>
    <div>
      <dt class="text-sm font-medium text-gray-500">Audience source</dt>
      <dd class="mt-1 text-sm text-gray-900">CRM</dd>
    </div>
    <div>
      <dt class="text-sm font-medium text-gray-500">Audience type</dt>
      <dd class="mt-1 text-sm text-gray-900">Saved Query</dd>
    </div>
  </dl>
</template>

<script>
import Numbro from '@/utils/numbro';

export default {
  props: {
    audience: {
      type: Object,
      required: true,
    },
  },
  computed: {
    estimatedSize() {
      const count = Number.parseInt(this.audience.model.count || 0, 10);

      return Numbro(count).format({
        thousandSeparated: true,
      });
    },
  },
};
</script>
